import classNames from 'classnames';
import { formatTaskDateTime } from '@/modules/common/helpers/taskDateTime.ts';
import { Icon, TooltipNew } from 'ui';
import { CalendarCancelIcon, CalendarCheckIcon } from 'ui/icons';

interface TaskDatesProps {
  classes?: {
    container?: string;
  };
  current_start_date: string;
  overdue_date: string;
}

const TaskDates = ({ current_start_date, overdue_date, classes }: TaskDatesProps) => {
  return (
    <div className={classNames('w-[200px] hidden sm:block space-y-1', classes?.container)}>
      <TooltipNew text="Start date">
        <div className="flex items-center gap-2.5">
          <Icon Source={CalendarCheckIcon} color="gray" />
          <span className="text-sm text-[#6B6B6B]">{formatTaskDateTime(current_start_date)}</span>
        </div>
      </TooltipNew>
      <TooltipNew text="Due date">
        <div className="flex items-center  gap-2.5">
          <Icon Source={CalendarCancelIcon} color="gray" />
          <span className="text-sm text-[#6B6B6B]">{formatTaskDateTime(overdue_date)}</span>
        </div>
      </TooltipNew>
    </div>
  );
};

export default TaskDates;
